
var swiper = new Swiper(".gallerySwiper", {
//   slidesPerView: 3,
  spaceBetween: 30,
  freeMode: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  // Add responsive breakpoints
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    // when window width is >= 1024px
    1024: {
      slidesPerView: 3,
      spaceBetween: 30,
    }
  }
});



var swiper = new Swiper(".everySwiper", {
  spaceBetween: 30,
  //  centeredSlides: true,
  loop: true,
  freeMode: true,
     scrollbar: {
        el: ".swiper-scrollbar",
        hide: true,
      },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    640: {
      slidesPerView: 2,
      spaceBetween: 5,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 5,
    }
  }
});






document.addEventListener("DOMContentLoaded", function() {
  const accordionButtons = document.querySelectorAll(".eqd-accordion__button");

  accordionButtons.forEach(button => {
    button.addEventListener("click", function() {
      const isExpanded = button.getAttribute("aria-expanded") === "true";
      const contentId = button.getAttribute("aria-controls");
      const content = document.getElementById(contentId);

      // Collapse all accordions
      accordionButtons.forEach(btn => {
        const contentToHide = document.getElementById(btn.getAttribute("aria-controls"));
        btn.setAttribute("aria-expanded", "false");
        if (contentToHide) {
          contentToHide.setAttribute("hidden", "");
        }
      });

      // If the clicked accordion was not expanded, expand it
      if (!isExpanded) {
        button.setAttribute("aria-expanded", "true");
        content.removeAttribute("hidden");
      }
    });
  });
});   